module.exports = __webpack_public_path__ + "static/media/Saira-Regular.23c6e24a.ttf";